var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "alert",
      class: ["message with-icon", _vm.customClass],
      style: _vm.componentStyle,
    },
    [
      _c("font-awesome-icon", {
        class: ["decorative", _vm.iconClass],
        attrs: {
          icon: _vm.$v6[_vm.iconStyle][_vm.iconName],
          "fixed-width": "",
        },
      }),
      _vm._v(" "),
      _c("h4", { staticClass: "title" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("message"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }